module.exports = __webpack_public_path__ + "static/img/3-04.45da2bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/3-04.png
// module id = 231
// module chunks = 0